export interface Drama {
  id: string;
  title: string;
  category: string;
  genre: string;
  year: number;
  region: string;
  rating: number;
  episodes: number;
  duration: string;
  cover: string;
  banner: string;
  synopsis: string;
  fullSynopsis: string;
  director: string;
  writer: string;
  cast: string[];
  tags: string[];
  popularity: number;
  publishDate: string;
  highlights: string[];
  episodeList: { index: number; title: string; desc: string }[];
  featured: boolean;
}

export const dramas: Drama[] = [
  {
    id: "kind-sister-in-law",
    title: "善良的嫂子",
    category: "电视剧",
    genre: "家庭情感",
    year: 2025,
    region: "中国大陆",
    rating: 9.1,
    episodes: 36,
    duration: "45分钟/集",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20emotional%20family%20drama%20poster%2C%20elegant%20Chinese%20woman%20in%20soft%20cream%20knitwear%20standing%20in%20a%20sunlit%20living%20room%2C%20gentle%20smile%2C%20soft%20warm%20red%20and%20beige%20tones%2C%20cinematic%20soft%20lighting%2C%20clean%20minimal%20background%2C%20editorial%20poster%20photography%2C%20high%20detail&width=600&height=900&seq=drama-kind-sister-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20scene%20of%20a%20serene%20Chinese%20family%20home%20interior%20with%20soft%20sunlight%20through%20linen%20curtains%2C%20wooden%20furniture%20and%20warm%20amber%20tones%2C%20emotional%20atmosphere%2C%20filmic%20soft%20light%2C%20shallow%20depth%20of%20field%2C%20high%20detail%20wide%20composition&width=1600&height=900&seq=drama-kind-sister-banner&orientation=landscape",
    synopsis:
      "一场突如其来的变故，让温柔坚韧的苏婉扛起了整个家。面对误解与偏见，她用一个女人的善良与担当，慢慢融化了身边每一个人的心。",
    fullSynopsis:
      "《善良的嫂子》讲述了一个关于亲情、责任与救赎的温暖故事。女主角苏婉在丈夫意外离世后，独自照顾年迈的公婆与年幼的小叔子顾言。面对家族遗产的纷争、邻里之间的流言蜚语，以及重组家庭的种种考验，她始终选择以善意回应世界。\n\n随着剧情推进，苏婉与顾言之间从隔阂到理解，从陌生到相依为命，两人共同撑起这个风雨飘摇的家。剧集用细腻的笔触描绘普通人的悲欢离合，探讨了善良是否是软弱的命题，最终给出了一个温暖而有力量的答案。",
    director: "周振国",
    writer: "苏念安",
    cast: ["actor-lin-qingwan", "actor-chen-zimo", "actor-zhou-yaqin", "actor-gao-haisheng", "actor-su-xiaoyu"],
    tags: ["家庭", "情感", "女性成长", "治愈", "热播"],
    popularity: 98600,
    publishDate: "2025-03-18",
    highlights: [
      "真实细腻的家庭群像刻画，每一集都有泪点",
      "女主角苏婉从柔弱到坚韧的完整人物弧光",
      "开放式的情感表达，引发观众对善意的深度讨论",
    ],
    episodeList: [
      { index: 1, title: "风雨骤至", desc: "苏婉的生活在一场意外后被彻底打乱，她被迫面对从未想象过的重担。" },
      { index: 2, title: "流言四起", desc: "邻里之间的闲言碎语传到了公婆耳中，苏婉选择沉默地扛下一切。" },
      { index: 3, title: "陌生的家人", desc: "小叔子顾言带着戒备回到家中，两人的相处充满摩擦与试探。" },
      { index: 4, title: "一碗热汤", desc: "苏婉用最朴素的方式照顾生病的顾言，隔阂第一次出现松动的痕迹。" },
      { index: 5, title: "遗产风波", desc: "远房亲戚觊觎家产，一场关于信任与利益的风波悄然袭来。" },
      { index: 6, title: "选择善良", desc: "在利益与亲情之间，苏婉做出了让所有人意外的决定。" },
    ],
    featured: true,
  },
  {
    id: "city-lights",
    title: "都市微光",
    category: "电视剧",
    genre: "都市职场",
    year: 2024,
    region: "中国大陆",
    rating: 8.6,
    episodes: 32,
    duration: "42分钟/集",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20workplace%20drama%20poster%2C%20confident%20young%20Chinese%20woman%20in%20a%20smart%20blazer%20against%20a%20blurred%20city%20skyline%20at%20dusk%2C%20warm%20amber%20office%20light%2C%20minimal%20elegant%20composition%2C%20clean%20background%2C%20editorial%20poster%20photography%2C%20high%20detail&width=600&height=900&seq=drama-city-lights-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20modern%20city%20office%20interior%20at%20night%20with%20amber%20desk%20lamps%2C%20glass%20walls%20overlooking%20city%20lights%2C%20soft%20cinematic%20glow%2C%20moody%20but%20warm%20atmosphere%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=drama-city-lights-banner&orientation=landscape",
    synopsis:
      "三位背景迥异的职场女性，在竞争激烈的都市中相互扶持，用专业与坚持点亮属于自己的那束微光。",
    fullSynopsis:
      "《都市微光》以一家快速成长的创意公司为背景，讲述了三位职场女性在事业、家庭与自我之间的挣扎与成长。有人在升职与背叛之间艰难抉择，有人在婚姻与理想之间反复权衡，也有人从职场新人一步步蜕变为团队的中坚力量。\n\n剧集以真实细腻的职场细节与温暖的人际关系，展现了当代都市人在压力之下依然选择互相照亮的动人图景。",
    director: "林以宁",
    writer: "郑小满",
    cast: ["actor-zhou-yaqin", "actor-su-xiaoyu", "actor-lin-qingwan"],
    tags: ["都市", "职场", "女性", "励志"],
    popularity: 76200,
    publishDate: "2024-09-05",
    highlights: ["三大女主群像刻画", "真实职场细节引发共鸣", "温暖治愈的成长故事"],
    episodeList: [],
    featured: true,
  },
  {
    id: "mountain-echo",
    title: "山海回声",
    category: "电视剧",
    genre: "年代情感",
    year: 2023,
    region: "中国大陆",
    rating: 8.9,
    episodes: 40,
    duration: "45分钟/集",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20period%20drama%20poster%2C%20Chinese%20family%20photograph%20style%20with%20warm%20sepia%20and%20red%20tones%2C%20traditional%20countryside%20house%20and%20mountains%20in%20soft%20haze%2C%20retro%20film%20grain%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=drama-mountain-echo-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20mountain%20village%20at%20golden%20hour%2C%20terraced%20fields%20and%20old%20stone%20houses%2C%20soft%20haze%20over%20distant%20peaks%2C%20cinematic%20sepia%20and%20amber%20tones%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=drama-mountain-echo-banner&orientation=landscape",
    synopsis:
      "跨越四十年的家族史诗，讲述一个普通家庭在时代洪流中的聚散离合，以及那份从未改变的乡土深情。",
    fullSynopsis:
      "《山海回声》以一个南方山村家庭为缩影，讲述了从改革开放到新世纪的四十余年间，三代人的命运沉浮。父辈坚守土地与承诺，子辈背井离乡追寻梦想，孙辈又在繁华都市中回望来路。\n\n剧集用克制的镜头语言与浓郁的时代气息，勾勒出一幅关于故乡、亲情与选择的时代画卷。",
    director: "周振国",
    writer: "苏念安",
    cast: ["actor-gao-haisheng", "actor-zhou-yaqin", "actor-li-mubai"],
    tags: ["年代", "家族", "乡土", "史诗"],
    popularity: 68900,
    publishDate: "2023-11-02",
    highlights: ["横跨四十年的宏大叙事", "浓厚的时代氛围", "真实动人的乡土情感"],
    episodeList: [],
    featured: false,
  },
  {
    id: "silent-witness",
    title: "沉默的证人",
    category: "电影",
    genre: "悬疑犯罪",
    year: 2024,
    region: "中国大陆",
    rating: 8.4,
    episodes: 1,
    duration: "118分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20poster%2C%20silhouette%20of%20a%20lone%20figure%20in%20a%20rainy%20moody%20alley%20at%20night%2C%20warm%20amber%20streetlight%20against%20deep%20shadows%2C%20minimal%20tense%20composition%2C%20cinematic%20poster%20photography%2C%20high%20detail&width=600&height=900&seq=movie-silent-witness-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Rainy%20night%20city%20alley%20with%20warm%20amber%20street%20lamps%20and%20wet%20reflective%20ground%2C%20tense%20cinematic%20mood%2C%20deep%20shadows%2C%20moody%20atmosphere%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=movie-silent-witness-banner&orientation=landscape",
    synopsis:
      "一起尘封多年的悬案重新被翻开，唯一的目击者却始终沉默。真相，是否真的能被时间掩埋？",
    fullSynopsis:
      "《沉默的证人》围绕一起十年前的悬案展开。当新的线索浮出水面，奉命调查的刑警发现，当年唯一的目击者如今已成了一位不愿再提起往事的普通人。\n\n在真相与代价之间，每个知情者都选择了沉默。影片以紧凑的节奏与层层反转，探讨了正义、恐惧与人性的复杂边界。",
    director: "高海生",
    writer: "郑小满",
    cast: ["actor-chen-zimo", "actor-gao-haisheng", "actor-li-mubai"],
    tags: ["悬疑", "犯罪", "反转", "烧脑"],
    popularity: 71300,
    publishDate: "2024-06-21",
    highlights: ["层层反转的剧本结构", "冷峻克制的影像风格", "对人性深度的探讨"],
    episodeList: [],
    featured: true,
  },
  {
    id: "summer-letter",
    title: "夏日来信",
    category: "电影",
    genre: "爱情文艺",
    year: 2023,
    region: "中国大陆",
    rating: 8.2,
    episodes: 1,
    duration: "105分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20summer%20art%20film%20poster%2C%20young%20couple%20bicycling%20along%20a%20seaside%20road%20at%20golden%20sunset%2C%20warm%20peach%20and%20amber%20tones%2C%20soft%20film%20grain%2C%20dreamy%20nostalgic%20mood%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=movie-summer-letter-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Warm%20sunset%20over%20a%20quiet%20seaside%20town%2C%20soft%20peach%20and%20golden%20sky%2C%20calm%20sea%20with%20gentle%20waves%2C%20dreamy%20nostalgic%20cinematic%20tone%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=movie-summer-letter-banner&orientation=landscape",
    synopsis:
      "一封迟到十年的信，让两个曾经错过的人重新相遇。有些遗憾，或许正是为了更好的重逢。",
    fullSynopsis:
      "《夏日来信》讲述了海边小镇上的一段青春往事。少年时的青梅竹马因一场误会各自远行，十年后，一封被尘封已久的信意外寄到了女主角手中。\n\n影片以细腻的情感与唯美的画面，讲述了一个关于遗憾、成长与重逢的温柔故事。",
    director: "林以宁",
    writer: "苏念安",
    cast: ["actor-su-xiaoyu", "actor-li-mubai"],
    tags: ["爱情", "文艺", "青春", "治愈"],
    popularity: 62400,
    publishDate: "2023-08-14",
    highlights: ["唯美治愈的画面风格", "细腻克制的感情表达", "关于遗憾与重逢的思考"],
    episodeList: [],
    featured: false,
  },
  {
    id: "star-kitchen",
    title: "星厨驾到",
    category: "综艺",
    genre: "美食竞技",
    year: 2025,
    region: "中国大陆",
    rating: 8.7,
    episodes: 12,
    duration: "70分钟/期",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20food%20reality%20show%20poster%2C%20chefs%20plating%20elegant%20dish%20in%20a%20warm%20modern%20kitchen%20with%20wooden%20counter%2C%20warm%20amber%20lighting%2C%20appetizing%20colorful%20food%2C%20clean%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=variety-star-kitchen-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Warm%20modern%20open%20kitchen%20with%20wooden%20counters%20and%20hanging%20copper%20pans%2C%20soft%20amber%20lighting%2C%20fresh%20colorful%20ingredients%2C%20cozy%20inviting%20atmosphere%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=variety-star-kitchen-banner&orientation=landscape",
    synopsis:
      "一群不同背景的明星厨师同台竞技，用一道道家常美食讲述背后的故事，赢取属于平凡人的高光时刻。",
    fullSynopsis:
      "《星厨驾到》是一档以美食竞技为核心的综艺节目。每期邀请不同领域的嘉宾化身厨师，在限定食材与时间内完成挑战。节目不仅有紧张刺激的比拼，更有每道菜背后温暖的人情故事。\n\n从街头小吃到家乡味道，节目用美食连接人与人之间的情感，传递对生活的热爱。",
    director: "王豆豆",
    writer: "综艺团队",
    cast: ["actor-zhou-yaqin", "actor-chen-zimo"],
    tags: ["美食", "竞技", "明星", "治愈"],
    popularity: 80500,
    publishDate: "2025-05-09",
    highlights: ["轻松治愈的美食氛围", "明星嘉宾的真实一面", "每期都有暖心故事"],
    episodeList: [],
    featured: true,
  },
  {
    id: "wild-trek",
    title: "荒野同行",
    category: "综艺",
    genre: "户外真人秀",
    year: 2024,
    region: "中国大陆",
    rating: 8.3,
    episodes: 10,
    duration: "85分钟/期",
    cover:
      "https://readdy.ai/api/search-image?query=Adventure%20outdoor%20reality%20show%20poster%2C%20hikers%20with%20backpacks%20standing%20on%20a%20windy%20mountain%20ridge%20at%20golden%20hour%2C%20warm%20amber%20light%20and%20windswept%20grass%2C%20cinematic%20epic%20mood%2C%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=variety-wild-trek-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Golden%20hour%20over%20vast%20windswept%20mountain%20plateau%20with%20warm%20amber%20light%2C%20dramatic%20clouds%20and%20distant%20peaks%2C%20epic%20cinematic%20adventure%20tone%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=variety-wild-trek-banner&orientation=landscape",
    synopsis:
      "六位嘉宾深入荒野，在真实的自然挑战中互相扶持，重新认识彼此，也重新认识自己。",
    fullSynopsis:
      "《荒野同行》把镜头对准真实的自然。六位背景各异的嘉宾组成队伍，在无人区完成一连串生存与协作挑战。没有剧本，只有真实的疲惫、争吵、和解与感动。\n\n节目用壮美的自然风光与真诚的人际互动，讲述了关于信任与成长的户外故事。",
    director: "王豆豆",
    writer: "综艺团队",
    cast: ["actor-gao-haisheng", "actor-su-xiaoyu", "actor-li-mubai"],
    tags: ["户外", "真人秀", "冒险", "纪实"],
    popularity: 65800,
    publishDate: "2024-04-12",
    highlights: ["真实无剧本的野外挑战", "壮美的自然影像", "嘉宾之间的真诚互动"],
    episodeList: [],
    featured: false,
  },
  {
    id: "long-night-clear",
    title: "长夜晴川",
    category: "电视剧",
    genre: "古装权谋",
    year: 2022,
    region: "中国大陆",
    rating: 8.8,
    episodes: 45,
    duration: "45分钟/集",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20historical%20drama%20poster%2C%20graceful%20woman%20in%20flowing%20traditional%20hanfu%20in%20deep%20warm%20red%20and%20gold%20tones%2C%20palace%20lanterns%20bokeh%2C%20soft%20cinematic%20light%2C%20minimal%20refined%20composition%2C%20high%20detail&width=600&height=900&seq=drama-long-night-clear-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20corridor%20at%20dusk%20lit%20by%20warm%20red%20lanterns%2C%20intricate%20wooden%20architecture%2C%20soft%20mist%2C%20moody%20elegant%20cinematic%20tone%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=drama-long-night-clear-banner&orientation=landscape",
    synopsis:
      "乱世之中，一位出身低微的女子凭借智慧与胆识步步为营，在权谋漩涡中守护心中所信。",
    fullSynopsis:
      "《长夜晴川》以架空王朝为背景，讲述了女主角晴川从一位不起眼的官家庶女，成长为影响朝局关键人物的传奇故事。她周旋于各方势力之间，既要守护家族的安危，也要坚守自己的底线。\n\n剧集以精良的服化道与缜密的权谋线，展现了乱世之中的爱恨情仇与家国大义。",
    director: "周振国",
    writer: "郑小满",
    cast: ["actor-zhou-yaqin", "actor-chen-zimo", "actor-li-mubai"],
    tags: ["古装", "权谋", "传奇", "女性"],
    popularity: 74100,
    publishDate: "2022-12-01",
    highlights: ["精良的服化道与美术", "缜密烧脑的权谋线", "立体丰满的女性角色"],
    episodeList: [],
    featured: false,
  },
  {
    id: "fog-city-mystery",
    title: "雾都疑云",
    category: "电视剧",
    genre: "悬疑推理",
    year: 2024,
    region: "中国大陆",
    rating: 8.5,
    episodes: 24,
    duration: "40分钟/集",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20series%20poster%2C%20lone%20detective%20in%20a%20trench%20coat%20on%20a%20foggy%20old%20town%20street%2C%20warm%20amber%20window%20lights%20against%20cool%20fog%2C%20moody%20cinematic%20tone%2C%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=drama-fog-city-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Foggy%20old%20riverside%20town%20at%20dusk%20with%20warm%20amber%20street%20lamps%20glowing%20through%20mist%2C%20moody%20atmospheric%20cinematic%20tone%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=drama-fog-city-banner&orientation=landscape",
    synopsis:
      "雾气笼罩的小城接连发生离奇案件，一位固执的刑警抽丝剥茧，揭开隐藏在平静表象下的惊人真相。",
    fullSynopsis:
      "《雾都疑云》设定在一座常年多雾的南方小城。一桩看似普通的失踪案，牵扯出一连串尘封多年的秘密。刑警队长凭借敏锐的直觉与执着的追查，逐步逼近真相。\n\n剧集以扎实的推理逻辑与压抑又迷人的氛围，探讨了记忆、愧疚与救赎的主题。",
    director: "林以宁",
    writer: "苏念安",
    cast: ["actor-gao-haisheng", "actor-chen-zimo", "actor-su-xiaoyu"],
    tags: ["悬疑", "推理", "氛围", "烧脑"],
    popularity: 69700,
    publishDate: "2024-10-16",
    highlights: ["扎实严密的推理逻辑", "极具氛围感的影像", "出人意料的大结局"],
    episodeList: [],
    featured: false,
  },
  {
    id: "chasing-light",
    title: "追光者",
    category: "电影",
    genre: "励志剧情",
    year: 2022,
    region: "中国大陆",
    rating: 8.6,
    episodes: 1,
    duration: "122分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Inspirational%20drama%20movie%20poster%2C%20determined%20young%20athlete%20running%20toward%20golden%20sunrise%20on%20a%20stadium%20track%2C%20warm%20amber%20and%20orange%20tones%2C%20uplifting%20cinematic%20mood%2C%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=movie-chasing-light-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Golden%20sunrise%20over%20a%20running%20track%20with%20long%20warm%20light%20rays%2C%20empty%20stadium%20in%20soft%20haze%2C%20uplifting%20hopeful%20cinematic%20tone%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=movie-chasing-light-banner&orientation=landscape",
    synopsis:
      "一个被命运夺去双腿的少年，用轮椅跑出了属于自己的赛道，也跑进了无数人的心里。",
    fullSynopsis:
      "《追光者》根据真实人物经历改编，讲述了一位因意外失去双腿的年轻人，如何在家人的支持与自己的坚持下，一步步成为轮椅竞速运动员的励志故事。\n\n影片以真挚的情感与充满力量的镜头，诠释了什么是永不言弃的人生。",
    director: "高海生",
    writer: "苏念安",
    cast: ["actor-li-mubai", "actor-gao-haisheng"],
    tags: ["励志", "真实改编", "运动", "感动"],
    popularity: 58200,
    publishDate: "2022-07-08",
    highlights: ["真实人物改编", "充满力量的情感表达", "鼓舞人心的人生故事"],
    episodeList: [],
    featured: false,
  },
  {
    id: "happy-family",
    title: "欢乐一家人",
    category: "电视剧",
    genre: "情景喜剧",
    year: 2023,
    region: "中国大陆",
    rating: 8.1,
    episodes: 48,
    duration: "25分钟/集",
    cover:
      "https://readdy.ai/api/search-image?query=Cheerful%20family%20sitcom%20poster%2C%20three%20generations%20of%20a%20happy%20Chinese%20family%20laughing%20together%20in%20a%20bright%20warm%20living%20room%2C%20warm%20red%20and%20cream%20tones%2C%20playful%20friendly%20mood%2C%20clean%20composition%2C%20high%20detail&width=600&height=900&seq=drama-happy-family-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Bright%20cozy%20family%20living%20room%20with%20warm%20cream%20sofas%20and%20red%20cushions%2C%20sunlit%20afternoon%2C%20warm%20welcoming%20atmosphere%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=drama-happy-family-banner&orientation=landscape",
    synopsis:
      "一个热热闹闹的大家庭，每天都在鸡飞狗跳的日常里上演着让人捧腹又暖心的故事。",
    fullSynopsis:
      "《欢乐一家人》以老城区的四合院为舞台，讲述了一大家子三代同堂的欢乐日常。爱操心的奶奶、爱较真的爸爸、毒舌又心软的妈妈，还有一群各怀绝技的孩子，每天都在上演啼笑皆非的故事。\n\n剧集用轻喜剧的方式，展现了中国式家庭最真实的烟火气与温情。",
    director: "王豆豆",
    writer: "郑小满",
    cast: ["actor-zhou-yaqin", "actor-gao-haisheng", "actor-su-xiaoyu"],
    tags: ["喜剧", "家庭", "轻喜", "下饭"],
    popularity: 63400,
    publishDate: "2023-02-20",
    highlights: ["轻松解压的下饭剧", "鲜活可爱的家庭成员", "满满的生活烟火气"],
    episodeList: [],
    featured: false,
  },
  {
    id: "voice-of-future",
    title: "声动未来",
    category: "综艺",
    genre: "音乐竞演",
    year: 2025,
    region: "中国大陆",
    rating: 8.9,
    episodes: 14,
    duration: "90分钟/期",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%2C%20singer%20performing%20on%20a%20warm%20lit%20stage%20with%20golden%20spotlight%20and%20soft%20haze%2C%20passionate%20emotional%20mood%2C%20warm%20amber%20tones%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=variety-voice-future-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Warm%20golden%20stage%20lights%20and%20soft%20haze%20in%20a%20concert%20arena%2C%20silhouettes%20of%20an%20audience%2C%20warm%20amber%20and%20orange%20tones%2C%20emotional%20cinematic%20concert%20mood%2C%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=variety-voice-future-banner&orientation=landscape",
    synopsis:
      "来自各地的音乐人同台竞演，用最真诚的声音打动观众，也让更多人听见平凡人的梦想。",
    fullSynopsis:
      "《声动未来》是一档聚焦原创与演绎的音乐竞演节目。选手们来自不同背景，有专业歌手，也有藏着梦想的普通人。他们用歌声讲述自己的故事，在舞台上完成一次次蜕变。\n\n节目以高质量的现场演出与真挚的情感表达，成为年度最受关注的音乐综艺之一。",
    director: "王豆豆",
    writer: "综艺团队",
    cast: ["actor-su-xiaoyu", "actor-li-mubai", "actor-zhou-yaqin"],
    tags: ["音乐", "竞演", "原创", "梦想"],
    popularity: 82900,
    publishDate: "2025-07-18",
    highlights: ["高质量的现场舞台", "感人至深的选手故事", "年度口碑音乐综艺"],
    episodeList: [],
    featured: true,
  },
];